import Responsive from "./Responsive";
// import SmoothScroll from './SmoothScroll';
import ToTop from "./ToTop";
import bowser from "bowser";
import inview from "jquery-inview";
import FloatAnimation from "./FloatAnimation";
import slick from "slick-carousel";
import { TweenMax, TimelineMax } from "gsap";
import Swiper from "swiper";
import remodal from "remodal";

if (bowser.msie === true) {
	let version = "ie_" + Math.floor(bowser.version);
	$("body").addClass("ie " + version);
} else if (bowser.msedge === true) {
	$("body").addClass("edge");
} else if (bowser.firefox === true) {
	$("body").addClass("ff");
} else if (bowser.tablet === true) {
	$("body").addClass("tablet");
}

if (bowser.mobile === true) {
	$("body").addClass("device--mobile");
	if (bowser.android === true) {
		$("body").addClass("device--mobile--android");
	}
}

let os,
	ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
} else {
	os = "";
}

$("body").addClass(os);

if (ua.indexOf("Android") > 0) {
	$("body").addClass("device--mobile");
	$("body").addClass("device--mobile--android");
}
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());

/* ===============================================
Smooth Scroll
=============================================== */
// const sms = new SmoothScroll();
// sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
let param = {
	target: ".c-col_floatNav",
	// stop_at: "",
	fixer: 400
};

const totop = new ToTop(param);
totop.exec();

let param_won = {
	target: "#wovn-translate-widget",
	// stop_at: ".l-footerimg",
	fixer: 400
};

const totop_won = new ToTop(param_won);
totop_won.exec();

/* ===============================================
# page fade in
=============================================== */
const _w = $(window);

setTimeout(() => {
	$('.js-page-fadein').addClass('is-active')
}, 0.1)

/* ===============================================
#	inview
=============================================== */
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty("--vh", `${vh}px`);

$(".js-inview-element").on("inview", function () {
	$(this).addClass("-is-active");
	$(this).off("inview");
});
$(".js-btn-scroll").on("click", function() {
	// $.scrollify.next();
	let section_lower_Y = $(".l-section_lower").offset().top;
	$("html,body").animate({ scrollTop: section_lower_Y }, 500, "swing");
});

/* ===============================================
#	blockfade パーツ全体をfadeINする。
=============================================== */
$(".js-block-fade").on("inview", function() {
	$(this).addClass("-is-active");
	setTimeout(() => {
		$(this)
			.find(".js-block-fade-child")
			.addClass("-is-active");
	}, 500);
	$(this).off("inview");
});

/* ===============================================
#	c-floatNav
=============================================== */
const belowMv = () => {
	const wct = $(window).scrollTop();
	const mvHeight = $('.p-halfwideSlide').height();
	if (wct > mvHeight/2) {
		return true;
	} else {
		return false;
	}
}
let timeoutId;
$(function () {
	if (!belowMv()) {
		$('.c-col_floatNav').addClass('-is-hide');
		$('#wovn-translate-widget').removeClass('-is-hide');
	}
	$('a').on('click', function () {
		$('.c-col_floatNav').addClass('-is-hide');
		$('#wovn-translate-widget').addClass('-is-hide');
	});
});
$(window).on('scroll', function () {
	if (belowMv()) {
		$('.c-col_floatNav').removeClass('-is-hide');
		$('#wovn-translate-widget').removeClass('-is-hide');
		} else {
			$('.c-col_floatNav').addClass('-is-hide');
			$('#wovn-translate-widget').addClass('-is-hide');
	}
});

/* ===============================================
#	footer float nav
=============================================== */
$(document).ready(function() {
	$(window).on("scroll", function() {
		let scrollHeight;
		let scrollPosition;
		let footHeight;
		scrollHeight = $(document).height(); //ドキュメントの高さ
		scrollPosition = $(window).height() + $(window).scrollTop(); //現在地
		footHeight =
			$(".p-footerContact").innerHeight() +
			$(".l-globalFooter").innerHeight() + 10; //footerの高さ（＝止めたい位置）
		if (scrollHeight - scrollPosition <= footHeight) {
			//ドキュメントの高さと現在地の差がfooterの高さ以下になったら
			$(".c-col_floatNav,#wovn-translate-widget").css({
				position: "absolute",
				bottom: footHeight
			});
		} else {
			$(".c-col_floatNav,#wovn-translate-widget").css({
				position: "fixed"
			});
		}
	});
});

/* ===============================================
#	mv 母の日のおすすめ
=============================================== */
// swiper
var halfWideSlide = new Swiper('.swiper-container', {
	slidesPerView: 1,
	autoplay: 2500,
	effect: "fade",
	speed: 800,
	loop: true
});
// scrollDown
$('.p-halfwideSlide_arrow_inner').on('click',function() {
	const targetElement = document.querySelector('#l-main');
	const rectTop = targetElement.getBoundingClientRect().top;
	const offsetTop = window.pageYOffset;
	const top = rectTop + offsetTop;
	window.scrollTo({
		top,
		behavior: 'smooth'
	});
});
// スクロールでMVフェードアウト
$(window).on("scroll", function () {
	let scrollTop = $(window).scrollTop();
	if (scrollTop > 30) {
		$('.p-halfwideSlide').addClass('-is-fadeout');
	} else {
		$('.p-halfwideSlide').removeClass('-is-fadeout');
	}
});